<template>
  <button @click.prevent="confirmModal" class="btn btn-primary w-100 mb-2">{{ buttonText }}</button>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ShoppingListModalConfirmButton",
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      hideModal: "hideModal",
      setShoppingListsVisibility: "shoppingList/setShoppingListsVisibility",
    }),
    confirmModal() {
      this.setShoppingListsVisibility(true);
      this.hideModal("shoppingListModal");
    },
  },
};
</script>
